import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
		clsx,
	} from "clsx"

	import {
		DialogTitle,
	} from "@headlessui/vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'VNotificationTitle',
  props: {
		className: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogTitle), {
    class: _normalizeClass(_unref(clsx)(
			__props.className,
			'text-balance text-center text-base/6 font-semibold text-zinc-950 sm:text-wrap sm:text-left sm:text-sm/6 dark:text-white'))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})